var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 0C5.808 0 0 5.838 0 13c0 7.1921 5.8079 13 13 13 7.162 0 13-5.8079 13-13 0-7.162-5.838-13-13-13zm1.0834 10.8634h3.25l-.2107 3.2199h-3.0393v8.125h-3.7917v-8.125H8.125v-3.25h2.1667v-2.949c0-2.1668 1.3843-4.0927 4.574-4.0927 1.5649 0 2.4677.1806 2.4677.1806l-.1505 3.0694h-1.7755c-1.1435 0-1.324.5718-1.324 1.4746v2.3472z"}));
}

Facebook.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = Facebook;

Facebook.default = Facebook;
